import { CookieStoreProvider } from './store/useCookieStore';
import { Provider } from './provider/Provider';
import { AppRouter } from './router/AppRouter';
import { Script } from './script';

export const App = () => {
  return (
    <CookieStoreProvider>
      <Provider>
        <Script />
        <AppRouter />
      </Provider>
    </CookieStoreProvider>
  );
};
